import Check from 'assets/icons/Check';
import Close from 'assets/icons/Close';
import Danger from 'assets/icons/Danger';
import Error from 'assets/icons/Error';
import Info from 'assets/icons/Info';
import useTranslation from 'common/hooks/useTranslation';
import { cn } from 'common/utils';
import React, { useEffect, useState } from 'react';

const bannerTypes = {
  neutral: {
    icon: null,
    styles: {
      border: 'border-l-4 border-gray-400',
      background: 'bg-white',
      text: 'text-gray-900',
    },
  },
  informative: {
    icon: <Info size='18px' color='#007bff' />,
    styles: {
      border: 'border-l-4 border-blue-500',
      background: 'bg-white',
      text: 'text-gray-900',
    },
  },
  positive: {
    icon: <Check size='18px' color='#4CAF50' />,
    styles: {
      border: 'border-l-4 border-green-500',
      background: 'bg-white',
      text: 'text-gray-900',
    },
  },
  warning: {
    icon: <Danger size='18px' color='#FFC107' />,
    styles: {
      border: 'border-l-4 border-yellow-500',
      background: 'bg-white',
      text: 'text-gray-900',
    },
  },
  negative: {
    icon: <Error size='18px' color='#DC3545' />,
    styles: {
      border: 'border-l-4 border-red-500',
      background: 'bg-white',
      text: 'text-gray-900',
    },
  },
};

const Banner = ({ type, message, details, onClose, contextTranslationKey }) => {
  const [expanded, setExpanded] = useState(false);
  const { t } = useTranslation(contextTranslationKey);

  useEffect(() => {
    setExpanded(false);
  }, [details, message, type]);

  const toggleReadMore = () => {
    setExpanded(!expanded);
  };

  const {
    icon,
    styles: { border, background, text },
  } = bannerTypes[type] || bannerTypes.neutral;

  const normalizedMessages = Array.isArray(message)
    ? message.filter(Boolean)
    : [message].filter(Boolean);

  return (
    <div
      className={cn(
        'flex justify-between items-start px-4 py-3 rounded-md shadow w-full',
        border,
        background,
      )}
    >
      <div className='flex gap-3 items-start w-full'>
        <div className='flex flex-col gap-2 text-sm w-full'>
          {normalizedMessages.map((msg, index) => (
            <div key={index} className='flex items-center gap-2'>
              <div className='flex-shrink-0'>{icon}</div>
              <span className={cn('font-medium', text)}>{msg}</span>
            </div>
          ))}
          {details && (
            <div className='flex flex-col gap-2 items-start'>
              {expanded ? (
                <div className='text-xs text-gray-700'>{details}</div>
              ) : null}
              <button
                className='text-vibrant-orange text-xs'
                onClick={toggleReadMore}
              >
                {expanded ? t('read-less') : t('read-more')}
              </button>
            </div>
          )}
        </div>
      </div>
      {onClose && (
        <Close
          size='18px'
          className='cursor-pointer ml-4 opacity-70 hover:opacity-100 transition-opacity'
          onClick={onClose}
        />
      )}
    </div>
  );
};

export default Banner;
